import f3tch from 'f3tch';

import profile from '../../api/profiles/json.profile.api';

export default (shortcut) =>
  f3tch('/crm/shortcuts/').profile(profile()).body(shortcut).post();
